export interface FAQItemType {
  id: number;
  category: string;
  question: string;
  answer: string;
}

const faqList: FAQItemType[] = [
  // 1. 서비스 이용 & 예약
  {
    id: 1,
    category: "서비스 이용 & 예약",
    question: "TiPot(티팟) 서비스 예약 및 이용 절차는 어떻게 되나요?",
    answer:
      "카카오 계정을 통해 간편 회원가입 및 로그인 후, 원하는 호스트의 다양한 온라인 서비스를 자유롭게 탐색하고 선택하실 수 있습니다. 서비스 상세 페이지에서 희망하는 날짜와 가능 시간대를 선택하신 후 신용/체크카드로 결제를 진행하면 즉시 예약이 확정됩니다. 예약된 서비스 시작 10분 전부터 마이페이지(예약 내역)에서 온라인 접속 링크가 활성화됩니다.",
  },
  {
    id: 2,
    category: "서비스 이용 & 예약",
    question: "예약한 서비스 일정 변경이 가능한가요?",
    answer:
      "서비스 시작 2시간 전까지는 기존 예약을 취소(100% 전액 환불)하신 후 원하시는 새로운 시간대로 다시 예약해 주셔야 합니다. 서비스 시작 2시간 이내에는 일정 변경 및 취소가 불가능하므로, 긴급한 일정 조정이 필요한 경우 마이페이지 [1:1 문의하기] 또는 이메일(help@jellypunch.com)로 신청해 주시면 안내해 드립니다.",
  },

  // 2. 결제 & 환불
  {
    id: 3,
    category: "결제 & 환불",
    question: "결제 방법 및 지원되는 카드사는 어떻게 되나요?",
    answer:
      "안전한 전자결제 PG사인 포트원(PortOne) 및 갤럭시아머니트리 결제 시스템을 통해 국내외 신용카드 및 체크카드 결제를 지원합니다. (**단, 현대카드는 결제 수단에서 제외됩니다.**) 신용카드 간편결제(앱카드) 및 일반 결제를 이용하실 수 있으며, 보안 SSL 암호화가 적용되어 안심하고 결제하실 수 있습니다.",
  },
  {
    id: 4,
    category: "결제 & 환불",
    question: "서비스 취소 및 환불 정책은 어떻게 적용되나요?",
    answer:
      "TiPot은 공정한 거래 환경 조성을 위해 다음과 같은 취소/환불 기준을 준수합니다:\n• **결제 후 10분 이내**: 유예 기간(Grace Period)이 적용되어 100% 무료 취소 및 환불됩니다.\n• **서비스 시작 2시간 전까지**: 마이페이지 취소 버튼을 통해 100% 무료 취소 및 카드 결제 승인 취소가 진행됩니다.\n• **서비스 시작 2시간 이내**: 서비스 임박 건으로 분류되어 취소 및 환불이 불가합니다.\n• **호스트 사정/노쇼**: 호스트의 불가피한 사정으로 서비스가 제공되지 않은 경우 100% 전액 환불 조치가 이루어집니다.",
  },
  {
    id: 5,
    category: "결제 & 환불",
    question: "결제 취소 후 환불금은 언제 입금되나요?",
    answer:
      "취소 완료 시 PG사를 통해 즉시 승인 취소 처리됩니다. 신용카드는 카드사 영업일 기준 3~5일 이내 한도 복구 또는 차기 청구 금액에서 차감되며, 체크카드는 계좌로 환불 금액이 자동 입금됩니다.",
  },

  // 3. 서비스 판매 & 등록
  {
    id: 6,
    category: "서비스 판매 & 등록",
    question: "TiPot에서 나만의 서비스를 등록하고 판매하려면 어떻게 해야 하나요?",
    answer:
      "TiPot에서는 별도의 복잡한 승인 절차 없이, 카카오 계정으로 가입한 사용자라면 누구나 자유롭게 나만의 서비스를 등록하여 판매할 수 있습니다. 마이페이지 또는 스튜디오 메뉴에서 서비스 카테고리, 대표 이미지, 상세 설명, 가격, 진행 가능 일정을 설정하시면 즉시 서비스 등록 및 판매가 시작됩니다.",
  },
  {
    id: 7,
    category: "서비스 판매 & 등록",
    question: "판매 수수료는 얼마인가요?",
    answer:
      "TiPot은 원활하고 안정적인 플랫폼 운영을 위해 서비스 이용 수수료 15%를 적용합니다. 구매자가 결제한 총 금액에서 15% 플랫폼 수수료가 차감된 **실제 정산 수익(85%)**이 서비스 이용 완료 시점에 판매자의 지갑으로 즉시 적립됩니다.",
  },

  // 4. 수익 정산 & 세금 신고
  {
    id: 8,
    category: "수익 정산 & 세금 신고",
    question: "판매 수익 정산 신청 및 출금 절차는 어떻게 되나요?",
    answer:
      "마이페이지 [정산/지갑] 탭에서 출금 가능 잔액을 확인하신 후 [환전 신청]을 진행하실 수 있습니다. (최소 출금 가능 금액: 10,000원 이상)\n• 최초 출금 신청 시 실명, 주민등록번호, 은행명, 계좌번호, 예금주 정보를 등록(KYC)해야 합니다.\n• 출금 신청된 대금은 정산 일정(매월 15일 및 말일, 월 2회)에 맞춰 등록하신 본인 명의 계좌로 입금 처리됩니다.",
  },
  {
    id: 9,
    category: "수익 정산 & 세금 신고",
    question: "원천징수 세금(3.3%) 신고 및 개인정보 처리는 어떻게 되나요?",
    answer:
      "소득세법 제145조(사업소득의 원천징수) 등 관계 법령에 의거하여 출금 이체 시 **사업소득세 3.0% + 지방소득세 0.3% (총 3.3%)가 원천징수 공제**된 후 실수령액이 이체됩니다.\n• 등록하신 실명, 주민등록번호, 계좌 정보는 국세청 원천징수 세금 신고 및 대금 입금 목적으로만 안전하게 암호화되어 관리됩니다.\n• 관계 법령에 따라 5년간 안전 보관 후 자동 파기되며, 타 용도로 절대 사용되거나 제3자에게 제공되지 않습니다.",
  },
  {
    id: 10,
    category: "수익 정산 & 세금 신고",
    question: "출금 신청이 거절(REJECTED)되는 사유와 재신청 방법은 무엇인가요?",
    answer:
      "예금주명과 회원 실명이 일치하지 않거나, 입력하신 계좌번호 오류, 주민등록번호 미입력/불일치 시 출금 신청이 거절될 수 있습니다. 정산 거절 시 출금 신청했던 금액은 지갑 잔액으로 100% 자동 소급 환불되며, 마이페이지 [정산 정보]에서 올바른 정보를 입력하신 후 언제든지 재신청하실 수 있습니다.",
  },

  // 5. 고객지원 & 문제해결
  {
    id: 11,
    category: "고객지원 & 문제해결",
    question: "서비스 시작 시간에 상대방이 접속하지 않거나 링크에 오류가 있을 때는?",
    answer:
      "서비스 시작 시간 10분 후까지 상대방이 입장하지 않거나 접속 링크에 오류가 발생하는 경우, 마이페이지 [1:1 문의하기] 또는 이메일(help@jellypunch.com)로 상황을 접수해 주세요. 사실 확인 후 즉시 100% 전액 환불 조치해 드립니다.",
  },
  {
    id: 12,
    category: "고객지원 & 문제해결",
    question: "고객센터 운영시간 및 문의 방법은 어떻게 되나요?",
    answer:
      "TiPot 고객센터는 평일 10:00 ~ 18:00 (점심시간 12:30 ~ 13:30 / 주말 및 공휴일 휴무) 운영됩니다. 마이페이지 [1:1 문의하기] 게시판 또는 이메일(help@jellypunch.com)로 문의사항을 남겨주시면 담당자가 확인 후 신속하게 답변해 드립니다.",
  },
];

export default faqList;
